import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

// Bottom-left station card with the full copy (index chip, tagline, label,
// blurb, Enter button). Renders on arrival at each station.
export const StationOverlay = ({ station, index, arrivalT, isArrived, onEnter }) => {
  const idx = String(index + 1).padStart(2, '0');
  return (
    <div className="pointer-events-none absolute inset-0">
      <AnimatePresence>
        {isArrived && (
          <motion.div
            key={station.id}
            initial={{ opacity: 0, filter: 'blur(12px)', y: 30 }}
            animate={{ opacity: 1, filter: 'blur(0px)', y: 0 }}
            exit={{ opacity: 0, filter: 'blur(12px)', y: 30 }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            className="pointer-events-auto glass rounded-2xl p-6 md:p-8 shadow-elegant absolute"
            style={{
              background: 'hsl(221 60% 11% / 0.94)',
              left: 'clamp(16px, 4vw, 96px)',
              right: 'clamp(16px, 4vw, 96px)',
              bottom: 'clamp(24px, 6vh, 120px)',
              maxWidth: 'min(460px, 100%)',
            }}
            data-testid={`station-card-${station.id}`}
          >
            <div className="flex items-center gap-3 mb-4">
              <span className="text-tertiary text-xs font-display tracking-[0.4em]">{idx}</span>
              <span className="h-px flex-1 bg-tertiary/40" />
              <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                Station {index + 1} of {arrivalT >= 0 ? 6 : 6}
              </span>
            </div>
            <p className="text-primary text-xs uppercase tracking-[0.3em] font-medium mb-3 font-display">
              {station.tagline}
            </p>
            <h2 className="font-display font-semibold text-3xl md:text-4xl text-foreground mb-3 leading-[1.05]">
              {station.label}
            </h2>
            <p className="font-sans text-muted-foreground leading-relaxed mb-6 text-sm md:text-base">
              {station.blurb}
            </p>
            <Button
              variant="hero"
              size="lg"
              onClick={onEnter}
              data-testid={`enter-${station.id}-btn`}
            >
              Enter
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default StationOverlay;
